import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCUb711vLhShS3pFNOmGkaSu1eU0r_VPNw",
  authDomain: "infinity-shoes-1d063.firebaseapp.com",
  projectId: "infinity-shoes-1d063",
  storageBucket: "infinity-shoes-1d063.firebasestorage.app",
  messagingSenderId: "7684595218",
  appId: "1:7684595218:web:de211249a8a678623cc2cb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
